import _o2sService from "./_o2sServices";

import { IFilter } from "../models/filters/filter";
import { IOrderFilter } from "../models/filters/orderFilter";
import { IOrderForm } from "../models/forms/orderForm";
import { IOrderPDTO } from "../models/dtos/orderPDTO";

import { API_CENTRE } from "./config";

export default class OrderServices extends _o2sService
{
    protected static override mainUrl:string = API_CENTRE + "/api/v1/orders";

    protected static override getUrlFilter<F extends IOrderFilter>(filter?: F): string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null) 
        {
            if ( filter.emittingSocietyId != null)
                url += `&EmittingSocietyId=${filter.emittingSocietyId}`;
            if ( filter.providerId != null)
                url += `&ProviderId=${filter.providerId}`;
            if ( filter.statusId != null)
                url += `&StatusId=${filter.statusId}`;
        }
        return url;
    }
    
    protected static override toDTO(obj:IOrderForm):IOrderPDTO {
        const dto = super.toDTO(obj) as IOrderPDTO;
        
        return dto;
    }
}